<div class="ml-5 mr-5" >

  <div class="m-3">
    <div class="d-flex align-items-center">
      <span class="title" style="margin: 0px 3px;">{{ actualMachine?.Name }}</span>
      <div class="supplier-state" style="margin: 0px 3px;" *ngIf="supplierState !== null" [ngClass]="{'active' : supplierState === true}"></div>
      <span class="notes" style="margin: 0px 3px;" *ngIf="machineOwner?.Name"> ({{ machineOwner?.Name }})</span>
    </div>
    <div *ngIf="actualMachine?.FenixVersion">{{ 'ver' | translateWithFallback }} {{ actualMachine?.FenixVersion }}</div>
    <div *ngIf="actualMachine?.CurrentStatus">{{ actualMachine?.CurrentStatus }} <!-- Change state to icon --></div>
  </div>

  <dx-tab-panel #tabPanel [showNavButtons]="true" [selectedIndex]="selectedIndex" [loop]="false" [animationEnabled]="false" [swipeEnabled]="true" iconPosition='start' (selectedIndexChange)="changeSelectTabIndex($event)">
    <dxi-item [title]="isSmallScreen ? '' : ('detail' | translateWithFallback)" icon='info'>
      <div class="ml-3 mr-3">
        <app-machine-info-config></app-machine-info-config>
      </div>
    </dxi-item>
    <dxi-item [title]="isSmallScreen ? '' : ('medium' | translateWithFallback)" icon='file'>
      <div class="ml-3 mr-3">
        <app-machine-medium [currentMachineId]="firstMachineId$"></app-machine-medium>
      </div>
    </dxi-item>
    <dxi-item [title]="isSmallScreen ? '' : ('machine-activity' | translateWithFallback)" icon='datatrending'>
      <div class="ml-3 mr-3">
        <app-machine-activity [currentMachineId]="firstMachineId$"></app-machine-activity>
      </div>
    </dxi-item>
    <dxi-item [title]="isSmallScreen ? '' : ('machine-part-info' | translateWithFallback)" icon='toolbox'>
      <div class="ml-3 mr-3">
        <app-machine-part-info [currentMachineId]="firstMachineId$"></app-machine-part-info>
      </div>
    </dxi-item>
  </dx-tab-panel>
</div>
